import React from 'react';
import { PopupDialog } from 'swag-client-common/components/info/popup-dialog';
import { Button, ButtonType } from 'swag-client-common/components/ui/button';
import classes from './permission-error-popup.scss';
export const PermissionErrorPopup = ({
  isOpen,
  onClose
}) => {
  const getContent = () => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
      className: classes.tip
    }, "If you need edit permission please contact Super Admin"), /*#__PURE__*/React.createElement("div", {
      className: classes.buttonBlock
    }, /*#__PURE__*/React.createElement(Button, {
      dataButton: "Close",
      type: ButtonType.primary,
      className: classes.button,
      onClick: onClose
    }, "Close")));
  };
  return /*#__PURE__*/React.createElement(PopupDialog, {
    open: isOpen,
    title: "You do not have permission to edit it",
    dataPopup: "PermissionErrorPopup",
    contentClass: classes.content,
    titleHeader: classes.titleHeader,
    titleClasses: classes.title,
    popupClassName: classes.popup,
    content: getContent(),
    onClose: onClose,
    showCloseButton: true
  });
};